// Types
import mixins from "vue-typed-mixins";
// Mixins
import ControllerBase from '../../mixins/ControllerBase';

// Main
const ControllerCookie = mixins(ControllerBase).extend({
  name: 'ControllerCookie',
  data() {
    return {
      isShown: false,
      form: {
        necessary: true,
        marketing: true,
        analytics: true
      }
    };
  },
  mounted() {
    const acceptedCookies = this.$getCookie('acceptedCookies');
    if (!acceptedCookies) {
      this.isShown = true;
    }
  },
  methods: {
    acceptCookies() {
      const accepted = [];
      if (this.form.necessary) {
        accepted.push('necessary');
      }
      if (this.form.marketing) {
        accepted.push('marketing');
      }
      if (this.form.analytics) {
        accepted.push('analytics');
      }
      this.$setCookie('acceptedCookies', accepted.join(','));
      this.isShown = false;
    }
  },
  render() {
    const {
      isShown,
      acceptCookies,
      form
    } = this;
    return this.renderContainer({
      isShown,
      acceptCookies,
      form
    });
  }
});
export default ControllerCookie;